import { Box, Flex, FlexProps, Spinner } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import {
  GET_RELATED_NEWS_QUERY_KEY,
  getRelatedNews,
} from "../api/newsScreenApi";
import { NewsCard } from "../../../components/news/NewsCard";
import { LayoutStyle } from "../../../types";
import { useIsSmallBreakpoint } from "../../../utils/useBreakpoints";

interface RelatedNewsProps {
  articleId: number;
  showDividers?: boolean;
}

export function RelatedNews({
  articleId,
  showDividers = false,
  cardSize = "m",
  ...props
}: RelatedNewsProps & { cardSize?: LayoutStyle["size"] } & FlexProps) {
  const isSmallBreakpoint = useIsSmallBreakpoint();
  const { isLoading, data, error } = useQuery({
    queryKey: [...GET_RELATED_NEWS_QUERY_KEY, articleId],
    queryFn: () => getRelatedNews(articleId ?? ""),
    enabled: !!articleId,
  });

  if (isLoading) {
    return (
      <Flex width="full" alignItems="center" justifyContent="center">
        <Spinner color="blaze.blaze" />
      </Flex>
    );
  }

  if (!data || error) {
    return null;
  }

  return (
    <Flex flexDirection="column" gap="32px" {...props}>
      {data?.data.payload.results.map((related, i) => {
        return (
          <>
            <NewsCard
              key={related.id}
              content={related}
              size={cardSize}
              titleFontSize={
                cardSize !== "m"
                  ? isSmallBreakpoint
                    ? "14px"
                    : "28px"
                  : "20px"
              }
            />
            {showDividers && i !== data?.data.payload.results.length - 1 ? (
              <Box
                key={related.id + "-divider"}
                width="100%"
                height="1px"
                bg="transparent.white.10"
              />
            ) : null}
          </>
        );
      })}
    </Flex>
  );
}
